// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"bbdd6ac2","268":"7b5f6a0d","323":"1356a13c","513":"137b924d","619":"8200bcaa"}[chunkId] + ".chunk.css";
};